import { useRef, useEffect, useState } from 'react'

export function useContainerDimensions(heightMode: 'compact' | 'full') {
  const containerRef = useRef<HTMLDivElement>(null)
  const [dimensions, setDimensions] = useState({ width: 400, height: 400 })

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const obs = new ResizeObserver(([entry]) => {
      const { width, height: containerH } = entry.contentRect
      const h =
        heightMode === 'full' ? Math.max(containerH, 400) : Math.min(width * 0.85, 500)
      setDimensions({ width, height: h })
    })
    obs.observe(el)
    return () => obs.disconnect()
  }, [heightMode])

  return { containerRef, dimensions }
}
